import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bmm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on an expired/invalid admin session: if an authenticated request
// comes back 401, clear the stale token and (only when in the admin area) send
// the user to the login screen. Bad-credential 401s from the login form are ignored.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const isLoginRequest = url.includes("/auth/login");
    if (status === 401 && !isLoginRequest && localStorage.getItem("bmm_token")) {
      localStorage.removeItem("bmm_token");
      if (window.location.pathname.startsWith("/admin")) {
        window.location.assign("/admin");
      }
    }
    return Promise.reject(error);
  }
);

export const voterApi = axios.create({ baseURL: API });

voterApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("bmm_voter_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const gameApi = axios.create({ baseURL: API });

gameApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("bmm_game_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Normalize FastAPI error detail (string | array | object) into a plain string so
// a 422 validation payload can never be rendered directly as a React child.
gameApi.interceptors.response.use(
  (res) => res,
  (error) => {
    const d = error.response?.data?.detail;
    if (d != null && typeof d !== "string") {
      error.response.data.detail = formatApiErrorDetail(d);
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
